
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { NO_INFORMATION } from "@/data/placeholders";
  import RouteParams from "@/entities/RouteParams";

  @Component
  export default class ShortenedText extends Vue {
    @Prop({ type: String, default: undefined }) readonly text!: string;
    @Prop({ type: Number, default: 70 }) readonly maxLength!: number;
    @Prop({ type: Object, default: () =>({}) }) readonly routeParams!: Partial<RouteParams<{ id: string }>>;


    emptyTextPlaceholder: string = NO_INFORMATION;

    get shouldTextBeShortened(): boolean {
      return this.text.length > this.maxLength;
    }

    get shortText(): string {
      const textMaxLength = this.text.substr(0, this.maxLength);
      const truncatedToLastSpace = textMaxLength.substr(0, textMaxLength.lastIndexOf(" "));
      return `${truncatedToLastSpace}...`;
    }
  }
